module.exports = __webpack_public_path__ + "static/media/fun11.52cd84db.png";